// extracted by mini-css-extract-plugin
export var closeButton = "_3n-3";
export var header = "_3n-0";
export var link = "_3n-1";
export var retryButton = "_3n-2";